
import { workIndexWorkListAPI } from '@/api/pm/task';
import { workWorkCollectAPI, workupdateWorkOrderAPI } from '@/api/pm/project';

import ProjectCell from '../components/ProjectCell';
import SectionHead from '../components/SectionHead';
import Draggable from 'vuedraggable';

export default {
  // 项目看板
  name: 'ProjectBoard',
  components: {
    ProjectCell: ProjectCell,
    SectionHead: SectionHead,
    Draggable: Draggable
  },
  props: {
    visible: Boolean
  },
  data: function data() {
    return {
      searchInput: '',
      list: []
    };
  },

  computed: {
    showList: function showList() {
      var _this = this;

      return this.list.filter(function (item) {
        return item.name.indexOf(_this.searchInput) != -1;
      });
    },
    collectList: function collectList() {
      return this.list.filter(function (item) {
        return item.collect == 1;
      });
    },
    showCollectList: function showCollectList() {
      var _this2 = this;

      return this.collectList.filter(function (item) {
        return item.name.indexOf(_this2.searchInput) != -1;
      });
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) {
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;

      workIndexWorkListAPI().then(function (res) {
        _this3.list = res.data;
      }).catch(function () {});
    },


    /**
     * 进入详情
     */
    enterDetail: function enterDetail(item) {
      this.$router.push({
        name: 'project-list',
        params: {
          id: item.work_id
        }
      });

      this.handleClose();
    },


    /**
     * 拖拽
     */
    moveItem: function moveItem(evt) {
      if (evt) {
        // 如果没有进行移动 不做处理
        if (evt.oldIndex == evt.newIndex) {
          return;
        }

        workupdateWorkOrderAPI({
          workIds: this.list.map(function (item) {
            return item.work_id;
          })
        }).then(function (res) {}).catch(function () {});
      }
    },


    /**
     * 收藏
     */
    collectClick: function collectClick(item) {
      workWorkCollectAPI({ work_id: item.work_id }).then(function (res) {
        item.collect = item.collect == 0 ? 1 : 0;
      }).catch(function () {});
    },


    /**
     * 关闭
     */
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    }
  }
};